import {
  type MessageHandler,
  useNativeMessageListener as useNativeMessagePackageListener
} from '@carvana/merch-native';
import { useContext, useMemo } from 'react';
import { isNonProd } from '~/constants/environment';
import ErrorContext from '~/context/srp/ErrorContext';
import useSebastianReadinessHandler from '~/hooks/common/useSebastianReadinessHandler';
import { generateErrorLogger } from '~/utilities/loggers';
import {
  useAddFavoriteHandler,
  useCloseModalHandler,
  useFetchFavoritesHandler,
  useSaveSearchHandler,
  useToggleTradeHandler
} from './handlers';
import { ListenerEvent, type ListenerEventType } from './handlers/constants';
import {
  useErrorHandler,
  useUpdateGeolocationHandler
} from '../common/handlers';

export default function useNativeMessageListener() {
  const addFavoriteHandler = useAddFavoriteHandler();
  const { setNativeError } = useContext(ErrorContext);
  const closeModalHandler = useCloseModalHandler();
  const errorHandler = useErrorHandler<ListenerEventType>();
  const fetchFavoritesHandler = useFetchFavoritesHandler();
  const saveSearchHandler = useSaveSearchHandler();
  const sebastianReadinessHandler = useSebastianReadinessHandler<ListenerEventType>();
  const toggleTradeHandler = useToggleTradeHandler();
  const updateGeolocationHandler =
    useUpdateGeolocationHandler<ListenerEventType>();

  const handlers = useMemo<Array<MessageHandler<ListenerEventType, any>>>(
    () => [
      addFavoriteHandler,
      closeModalHandler,
      errorHandler,
      fetchFavoritesHandler,
      saveSearchHandler,
      sebastianReadinessHandler,
      toggleTradeHandler,
      updateGeolocationHandler
    ],
    [
      addFavoriteHandler,
      closeModalHandler,
      errorHandler,
      fetchFavoritesHandler,
      saveSearchHandler,
      sebastianReadinessHandler,
      toggleTradeHandler,
      updateGeolocationHandler
    ]
  );

  useNativeMessagePackageListener<ListenerEventType>({
    handlers,
    knownEvents: ListenerEvent,
    logErrorToTelemetry: generateErrorLogger('SRP native message listener'),
    logErrorToUser(_err) {
      setNativeError(new Error('Something went wrong. Please try again.'));
    },
    verboseLogs: isNonProd
  });
}
